import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SummarizeIcon from '@mui/icons-material/Summarize';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import GroupsIcon from '@mui/icons-material/Groups';
import LinkIcon from '@mui/icons-material/Link';

import { Divider } from '@mui/material';

const Sidebar = ({ open, onClose }) => {

  // This is list of Menu Items to be displayed in sidebar. More options can be added here.
  const menuItems = [
    { text: 'Summary', icon: <SummarizeIcon />, path: '/' },
    {
      text: 'Measurements Dashboard',
      icon: <OpenInNewIcon />,
      path: 'https://openghg.github.io/decc_dashboard/'
    },
    // { text: 'Reports', icon: <SummarizeIcon />, path: '/Reports' },
    { text: 'About', icon: <GroupsIcon />, path: '/AboutUs' },
    { text: 'Related Links', icon: <LinkIcon />, path: '/RelatedLinks' }
  ];
  
  const handleLinkClick = (path) => {
    if (path === 'https://openghg.github.io/decc_dashboard/') {
      window.open(path, '_blank');
    } else {
      window.location.href = path;
      onClose();
    }
  };

  return (
    // Renders the sidebar with menuItems
    <Drawer
      sx={{
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          zIndex:1,
          paddingTop:2.5
        },
  
      }}
      variant="persistent"
      anchor="left"
      open={open}
      onClose={onClose}
    >
      <div style={{ paddingTop: '64px' }}>
        <Divider></Divider>
        <List sx={{marginTop: {xs:5, sm:2, md:0}}}>
          {menuItems.map((item) => (
            <ListItem key={item.text} button className={`joyride-${item.text.replace(/\s+/g, '-').toLowerCase()}`} onClick={() => handleLinkClick(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
        <Divider></Divider>
      </div>
    </Drawer>
  );
};

export default Sidebar;
